import { CmsRegistrationOrderConfirmationPageHeader } from '../../models/registration-order-confirmation/cms-registration-order-confirmation-page-header.interface';

export const mockCmsRegistrationOrderConfirmationPageHeader: CmsRegistrationOrderConfirmationPageHeader =
  {
    registrationOrderConfirmationPageTitle: "That's it, you’re all set!",
    registrationOrderConfirmationPageSubtitle:
      'Registration and protection confirmed. We’ll send you a confirmation email shortly.',
  };
